import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

// import NotFoundComponent from '@/components/NotFoundComponent'
import Index from '@/page/main/index'
import Contacts from '@/page/main/contacts'

import Project from './project'
import Meeting from './meeting'
import Seal from './seal'
import User from './user'
import Set from './set'
import Mobile from './mobile'

import Asset from './asset'
import Contract from './contract'
import Storage from './storage'
import Pay from './pay'
import Common from './common'
import Car from './car'

import Consumable from './consumable'

import Personnel from './personnel'
import Purchase from './purchase'

import Notice from './notice'
import Disk from './disk'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      meta: {
        type: ['index', ''],
        title: '象山水务集团 - 内部管理系统'
      },
      component: Index
    }, {
      path: '/SignIn',
      meta: {
        type: ['index', ''],
        title: '系统登录'
      },
      component: Index
    }, {
      path: '/Contacts',
      meta: {
        type: ['contacts', ''],
        title: '通讯录'
      },
      component: Contacts
    },
    Project,
    Meeting,
    Seal,
    User,
    Set,
    Mobile,

    Asset,
    Contract,
    Storage,
    Pay,
    Common,

    Consumable,

    Personnel,
    Purchase,
    Car,
    Notice,
    Disk,
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})


//路由判断 如果没有用户数据调至登录页
function browserRedirect() {
  var sUserAgent = navigator.userAgent.toLowerCase();
  var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
  var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
  var bIsMidp = sUserAgent.match(/midp/i) == "midp";
  var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
  var bIsAndroid = sUserAgent.match(/android/i) == "android";
  var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
  var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";

  if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM)) {
    return false
  }
  return true
}
//路由跳转之前
router.beforeEach((to, from, next) => {
  // browserRedirect()
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || browserRedirect()) {
    if (!(to.fullPath.toLowerCase().match('/m/') || to.fullPath.toLowerCase().match('/m$'))) {
      // 跳转到移动版
      router.push('/m' + to.path);
    }
  }

  // console.log(to)
  // 仓库管理员相关判断
  // 仓库页时，更新管理员信息
  if (to.fullPath.toLowerCase().match('/storage')) {
    ajax.get('/storage/manager/houses', '', (res) => {
      store.commit('set_managerStorage', res.vo.array)
    })
  }

  // 判断是否手机版
  if (to.fullPath.toLowerCase().match('/m/') || to.fullPath.toLowerCase().match('/m$')) {
    store.commit('set_isMobile', true)
  }

  // 通讯录初始化
  store.commit("set_contactCurNode", {})
  // 初始化UserData
  // console.log(store.state.main.userData)
  if (store.state.main.userData.accesstoken) {
    ajax.get('/user/info', '', (res) => {
      store.commit('set_userData', res.vo)
    })
  }

  // 设置二级目录
  if (to.meta.type) {
    let _mainPath = to.meta.type[0]
    let _subPath = to.meta.type[1]
    store.commit('SET_TYPE', {
      main: _mainPath,
      sub: _subPath
    })
  }

  // 设置路由URL
  store.commit('SET_ROUTER_URL', to.fullPath)

  // 初始化项目审核表
  if (to.fullPath.toLowerCase().match('/approval/info')) {

    store.commit('set_projectTable', {
      status: false,
      applyId: "",
      tableType: "",
    })
  }

  // 修改TITLE
  document.title = to.meta.title ? to.meta.title + ' - 象山水务集团' : "象山水务集团 - 内部管理系统"

  // NEXT
  next()
})
// 路由跳转之后
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js